module.exports = __webpack_public_path__ + "img/red.c7312a65.webp";